"use client";

import { ErrorBoundary } from "@offstreetparking/instrumentation/client";
import type { ReactNode } from "react";
import { UnhandledRunTimeError } from "~/components/feedback/UnhandledRunTimeError";

export function ErrorBoundaryProvider({ children }: { children: ReactNode }) {
	return (
		<ErrorBoundary
			fallback={({ eventId, error }: { eventId: string | null; error: unknown }) => (
				<UnhandledRunTimeError eventId={eventId} error={error} onReload={() => window.location.reload()} />
			)}
		>
			{children}
		</ErrorBoundary>
	);
}
